import linkify from "linkifyjs/html";
import { DirectiveOptions } from "vue";

export const highlightedLinkify: DirectiveOptions = {
  bind: (el, binding) => {
    const { query, options } = binding.value;
    const linkified = linkify(el.innerHTML, options);
    const queryRegex = new RegExp(`${query}`, "gi");
    el.innerHTML = linkified
      .replace(queryRegex, (match) => `<b>${match}</b>`)
      .replace(/href="([^"]*)"/g, (url) => url.replace(/<b>|<\/b>/g, ""));
  }
};
